import { Component } from '@angular/core';
import { NavController, LoadingController, ToastController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { FormBuilder, Validators } from '@angular/forms';
import * as firebase from 'firebase';
import { ConfigurationServices } from '../../services';
import { PrintServices } from '../../../services/printServices';

@Component({
  selector: 'page-configuration-close-cash-create',
  templateUrl: 'configuration-close-cash-create.html'
})

export class ConfigurationCloseCashCreate {

  form: any;
  firestore;
  action: string = 'create';
  close_cash: any;
  denominationsArray: any;
  groupedDenominations: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public http: HttpClient,
    public loadingCtrl: LoadingController,
    public translate: TranslateService,
    private configurationServices: ConfigurationServices,
    public fb: FormBuilder,
    private toastCtrl: ToastController,
    private printServices: PrintServices) {

    this.action = this.navParams.get('action');
    this.close_cash = this.navParams.get('close_cash') || {};

    this.firestore = firebase.firestore();

    if (this.action === 'create') {
      this.form = this.fb.group({
        name: [this.configurationServices.biclosecash_cash_name + " - " + this.configurationServices.biclosecash_historial_name, Validators.required],
        comment: [''],
        moneda001: [0],
        moneda002: [0],
        moneda005: [0],
        moneda010: [0],
        moneda020: [0],
        moneda050: [0],
        moneda1: [0],
        moneda2: [0],
        billete5: [0],
        billete10: [0],
        billete20: [0],
        billete50: [0],
        billete100: [0],
        billete200: [0],
        billete500: [0],
        cash_init: [0],
        cash_total: [0],
        cash_mismatch: [0],
        card_concept: [''],
        card_import: [0],
        card_difference: [0],
      });
      this.calcularTotalEfectivo();
      // Actualizamos el total cada vez que se cambia un valor en los campos
      this.form.valueChanges.subscribe(values => {
        this.calcularTotalEfectivo();
      });
    } else {//case view
      this.form = this.fb.group({
        name: [{ value: this.close_cash.name, disabled: true }],
        comment: [{ value: this.close_cash.comment, disabled: false }],
        moneda001: [{ value: this.close_cash.denominations['0.01'], disabled: true }],
        moneda002: [{ value: this.close_cash.denominations['0.02'], disabled: true }],
        moneda005: [{ value: this.close_cash.denominations['0.05'], disabled: true }],
        moneda010: [{ value: this.close_cash.denominations['0.10'], disabled: true }],
        moneda020: [{ value: this.close_cash.denominations['0.20'], disabled: true }],
        moneda050: [{ value: this.close_cash.denominations['0.50'], disabled: true }],
        moneda1: [{ value: this.close_cash.denominations['1'], disabled: true }],
        moneda2: [{ value: this.close_cash.denominations['2'], disabled: true }],
        billete5: [{ value: this.close_cash.denominations['5'], disabled: true }],
        billete10: [{ value: this.close_cash.denominations['10'], disabled: true }],
        billete20: [{ value: this.close_cash.denominations['20'], disabled: true }],
        billete50: [{ value: this.close_cash.denominations['50'], disabled: true }],
        billete100: [{ value: this.close_cash.denominations['100'], disabled: true }],
        billete200: [{ value: this.close_cash.denominations['200'], disabled: true }],
        billete500: [{ value: this.close_cash.denominations['500'], disabled: true }],
        cash_init: [{ value: this.close_cash.cash_init, disabled: true }],
        cash_total: [{ value: this.close_cash.cash_total, disabled: true }],
        cash_mismatch: [{ value: this.close_cash.cash_mismatch, disabled: true }],
        card_concept: [{ value: this.close_cash.card_concept || '', disabled: true }],
        card_import: [{ value: this.close_cash.card_import || 0, disabled: true }],
        card_difference: [{ value: this.close_cash.card_difference || 0, disabled: true }],
      });
      const denominations = this.close_cash.denominations;
      this.denominationsArray = Object.keys(denominations).map(key => ({
        key: parseFloat(key),
        value: denominations[key as keyof typeof denominations]
      })).sort((a, b) => a.key - b.key);
      // Agrupar en filas de 3 elementos
      this.groupedDenominations = [];
      for (let i = 0; i < this.denominationsArray.length; i += 3) {
        this.groupedDenominations.push(this.denominationsArray.slice(i, i + 3));
      }
    }

  }

  // Calcula el total efectivo y el descuadre de caja
  calcularTotalEfectivo() {
    const valores = this.form.value;

    const totalEfectivo = this.globals.round2decimal(
      valores.moneda001 * 0.01 +
      valores.moneda002 * 0.02 +
      valores.moneda005 * 0.05 +
      valores.moneda010 * 0.10 +
      valores.moneda020 * 0.20 +
      valores.moneda050 * 0.50 +
      valores.moneda1 * 1 +
      valores.moneda2 * 2 +
      valores.billete5 * 5 +
      valores.billete10 * 10 +
      valores.billete20 * 20 +
      valores.billete50 * 50 +
      valores.billete100 * 100 +
      valores.billete200 * 200 +
      valores.billete500 * 500);

    const inicioCaja = this.globals.round2decimal(valores.cash_init);
    const mismatch = this.configurationServices.biclosecash_arqueo + inicioCaja;
    const saldo = totalEfectivo - mismatch;
    /*const descuadre = this.globals.round2decimal(totalEfectivo - inicioCaja);
    const total_with_tickets = descuadre - this.configurationServices.biclosecash_total_cash; //descuadre - Efectivo en tickets
    const total_with_arqueo = this.configurationServices.biclosecash_total_outgoing_cash - this.configurationServices.biclosecash_total_incoming_cash; //total_with_tickets - arqueo
    const mismatch = total_with_tickets - total_with_arqueo;*/

    const mismatc_card = valores.card_import - this.configurationServices.biclosecash_total_card;
    // Actualizamos los valores de los campos cash_total y cash_mismatch
    this.form.get('cash_total').setValue(totalEfectivo, { emitEvent: false });
    this.form.get('cash_mismatch').setValue(saldo.toFixed(2), { emitEvent: false });
    this.form.get('card_difference').setValue(mismatc_card.toFixed(2), { emitEvent: false });
  }

  async check() {
    //Comprovamos limites de la licencia
    if (!this.form.valid) {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('general-acepta-minusculas-puntos-guiones'),
        duration: 3000,
        position: 'top'
      });
      toast.present();
    } else {
      //prepare data
      var denominations = {
        "1": this.form.value.moneda1,
        "2": this.form.value.moneda2,
        "5": this.form.value.billete5,
        "10": this.form.value.billete10,
        "20": this.form.value.billete20,
        "50": this.form.value.billete50,
        "100": this.form.value.billete100,
        "200": this.form.value.billete200,
        "500": this.form.value.billete500,
        "0.01": this.form.value.moneda001,
        "0.02": this.form.value.moneda002,
        "0.05": this.form.value.moneda005,
        "0.10": this.form.value.moneda010,
        "0.20": this.form.value.moneda020,
        "0.50": this.form.value.moneda050,
      }
      var tickets = [];
      for (let ticket of this.configurationServices.biclosecash_tickets) {
        tickets.push(ticket.UID);
      }
      var ticketsCanceled = [];
      for (let ticket of this.configurationServices.biclosecash_tickets_canceled) {
        ticketsCanceled.push(ticket.TICKET_TIMELINE);
      }

      //set data
      var data = {
        UID_RESTAURANT: this.globals.restaurant_uid,
        name: this.form.value.name,
        comment: this.form.value.comment,
        cash_init: this.form.value.cash_init,
        cash_total: this.form.value.cash_total,
        cash_mismatch: this.form.value.cash_mismatch,
        denominations: denominations,
        created_at: new Date(),
        user_closed: this.globals.user_name + "-" + this.globals.user_email,
        total_incoming_cash: this.configurationServices.biclosecash_total_incoming_cash,
        total_outgoing_cash: this.configurationServices.biclosecash_total,
        //
        total: this.configurationServices.biclosecash_total,
        total_notax: this.configurationServices.biclosecash_total_notax,
        total_tax: this.configurationServices.biclosecash_total_tax,
        total_taxes: this.configurationServices.biclosecash_total_taxes,
        total_cash: this.configurationServices.biclosecash_total_cash,
        total_card: this.configurationServices.biclosecash_total_card,
        total_not_specified: this.configurationServices.biclosecash_total_not_specified,
        total_stripe: this.configurationServices.biclosecash_total_stripe,
        total_paypal: this.configurationServices.biclosecash_total_paypal,
        total_payplaza: this.configurationServices.biclosecash_total_payplaza,
        total_verifone: this.configurationServices.biclosecash_total_verifone,
        total_btc: this.configurationServices.biclosecash_total_btc,
        total_bch: this.configurationServices.biclosecash_total_bch,
        total_dai: this.configurationServices.biclosecash_total_dai,
        total_doge: this.configurationServices.biclosecash_total_doge,
        total_eth: this.configurationServices.biclosecash_total_eth,
        total_ltc: this.configurationServices.biclosecash_total_ltc,
        total_usdc: this.configurationServices.biclosecash_total_usdc,
        total_redsys: this.configurationServices.biclosecash_total_redsys,
        total_getnet: this.configurationServices.biclosecash_total_getnet,
        total_comerciaglobalpay: this.configurationServices.biclosecash_total_comerciaglobalpay,
        total_bank_transfer: this.configurationServices.biclosecash_total_bank_transfer,
        total_american_express: this.configurationServices.biclosecash_total_american_express,
        total_bizum: this.configurationServices.biclosecash_total_bizum,
        total_online: this.configurationServices.biclosecash_total_online,
        total_bank_draft: this.configurationServices.biclosecash_total_bank_draft,
        total_cryptocurrencies: this.configurationServices.biclosecash_total_cryptocurrencies,
        total_ticket_restaurant: this.configurationServices.biclosecash_total_ticket_restaurant,
        total_discount: this.configurationServices.biclosecash_total_discount,
        total_invite: this.configurationServices.biclosecash_total_invite,
        total_restaurant_ticket: this.configurationServices.biclosecash_total_restaurant_ticket,
        total_line_discount: this.configurationServices.biclosecash_total_line_discount,
        total_tips: this.configurationServices.biclosecash_total_tips,
        tip_cash: this.configurationServices.biclosecash_tip_cash,
        tip_card: this.configurationServices.biclosecash_tip_card,
        tip_stripe: this.configurationServices.biclosecash_tip_stripe,
        tip_paypal: this.configurationServices.biclosecash_tip_paypal,
        tip_payplaza: this.configurationServices.biclosecash_tip_payplaza,
        tip_verifone: this.configurationServices.biclosecash_tip_verifone,
        tip_not_specified: this.configurationServices.biclosecash_tip_not_specified,
        tip_redsys: this.configurationServices.biclosecash_tip_redsys,
        tip_getnet: this.configurationServices.biclosecash_tip_getnet,
        tip_comerciaglobalpay: this.configurationServices.biclosecash_tip_comerciaglobalpay,
        tip_bank_transfer: this.configurationServices.biclosecash_tip_bank_transfer,
        tip_american_express: this.configurationServices.biclosecash_tip_american_express,
        tip_bizum: this.configurationServices.biclosecash_tip_bizum,
        tip_online: this.configurationServices.biclosecash_tip_online,
        tip_bank_draft: this.configurationServices.biclosecash_tip_bank_draft,
        tip_cryptocurrencies: this.configurationServices.biclosecash_tip_cryptocurrencies,
        tip_ticket_restaurant: this.configurationServices.biclosecash_tip_ticket_restaurant,
        history: this.configurationServices.biclosecash_history,
        tickets: tickets,
        ticketsCanceled: ticketsCanceled,
        periodo: this.configurationServices.biclosecash_historial_name,
        cash_name: this.configurationServices.biclosecash_cash_name,
        arqueo: this.configurationServices.biclosecash_arqueo,
        card_concept: this.form.value.card_concept,
        card_import: this.form.value.card_import,
        card_difference: this.form.value.card_difference,
        total_tpv: this.configurationServices.biclosecash_total_tpv,
        total_online_methods: this.configurationServices.biclosecash_total_online_methods,
        total_others: this.configurationServices.biclosecash_total_others
      }
      if (this.action === 'create') {
        this.firestore.collection('close_cashes').add(data).then(doc => {
          this.globals.launchToast(this.translate.instant('general-guardado-correctamente'), 1000, 'top');
          //add new closecash to list
          var _data = {
            UID: doc.id,
            date_final: data.created_at
          };
          var mergedData = {
            ..._data,
            ...data,
          };
          this.configurationServices.biclosecash_history_close_cash.push(mergedData);
          //
          this.navCtrl.pop();
        });
      } else {
        this.firestore.collection('close_cashes').doc(this.close_cash.UID).update({
          comment: this.form.getRawValue().comment
        }).then(doc => {
          this.globals.launchToast(this.translate.instant('general-guardado-correctamente'), 1000, 'top');
          let index = this.configurationServices.biclosecash_history_close_cash.findIndex(x => x.UID === this.close_cash.UID);
          //Actualizamos el valor en el listado
          if (index >= 0) {
            this.configurationServices.biclosecash_history_close_cash[index].comment = this.form.getRawValue().comment;
          }
          this.navCtrl.pop();
        });
      }
    }
  }

  mismatchCss() {
    if (this.form.value.cash_mismatch >= 0) {
      let cssClasses = {
        'text-accepted': true
      }
      return cssClasses;
    } else {
      let cssClasses = {
        'text-denied': true
      }
      return cssClasses;
    }
  }

  mismatchCardCss() {
    if (this.form.value.card_difference >= 0) {
      let cssClasses = {
        'text-accepted': true
      }
      return cssClasses;
    } else {
      let cssClasses = {
        'text-denied': true
      }
      return cssClasses;
    }
  }

  print() {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-imprimiendo')
    });
    loadingPopup.present();
    this.globals.print_content = document.getElementById('print_close_cash_create');
    var interval = setInterval(() => {
      this.printServices.printNow("print_close_cash_create");
      loadingPopup.dismiss();
      clearInterval(interval);
    }, 1000);
  }

}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-close-cash/configuration-close-cash-create/configuration-close-cash-create.ts